import { useQuery } from '@tanstack/react-query';
import type { PaletteResultRow } from './usePaletteSearch';
import { paletteSearchKey } from '@dashboard/lib/queryKeys';

// Same-origin by default — the site app proxies /docs to the docs app in local dev
// and production (checkoutpage.dev/docs, checkoutpage.com/docs). Override per env
// (e.g., Vercel previews) by setting REACT_APP_DOCS_SEARCH_URL.
export const DOCS_SEARCH_URL =
  (import.meta as any).env?.REACT_APP_DOCS_SEARCH_URL || '/docs/api/search';

interface FumadocsRow {
  type: 'page' | string;
  id: string;
  url: string;
  content: string;
}

export function useDocsSearch(query: string) {
  const enabled = query.length >= 2;
  const q = useQuery<PaletteResultRow[]>({
    queryKey: paletteSearchKey('docs', 'global', query),
    queryFn: async () => {
      const url = `${DOCS_SEARCH_URL}?query=${encodeURIComponent(query)}`;
      const res = await fetch(url);
      if (!res.ok) throw new Error(`docs search failed: ${res.status}`);
      const rows = (await res.json()) as FumadocsRow[];
      return (rows || []).slice(0, 10).map(row => ({
        id: row.id,
        label: row.content?.split('\n')[0] || 'Help article',
        subtitle: row.url,
        path: row.url.startsWith('http')
          ? row.url
          : `https://checkoutpage.com${row.url.startsWith('/') ? '' : '/'}${row.url}`,
      }));
    },
    enabled,
    staleTime: 30_000,
  });
  return { ...q, data: q.data ?? [] };
}
